export const getTranslatedStay = ({
  unit,
  count,
  intl,
}: {
  unit: string;
  count: number | string;
  intl: any;
}): string => {
  if (!unit && !count) {
    return "";
  }

  if (unit === "V") {
    return intl.formatMessage({
      id: `ChangeTicketDetails.V`,
    });
  }

  return `${count} ${intl.formatMessage({
    id: `ChangeTicketDetails.${unit !== "SU" ? unit : "Days"}.${
      count > -1 && count < 5 ? count : "more"
    }`,
  })}${
    unit === "SU"
      ? ` ${intl.formatMessage({
          id: "ChangeTicketDetails.SU.additional",
        })}`
      : ""
  }`;
};
